export const FETCH_LOCATION_BASED_REQUEST = "FETCH_LOCATION_BASED_REQUEST";
export const FETCH_LOCATION_BASED_SUCCESS = "FETCH_LOCATION_BASED_SUCCESS";
export const FETCH_LOCATION_BASED_FAILURE = "FETCH_LOCATION_BASED_FAILURE";